module.exports = __webpack_public_path__ + "officialStatic/img/new1.dc928c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/new1.png
// module id = noiG
// module chunks = 0